import { defineMessages } from 'react-intl';

export const JobReportGuestAuthMessages = defineMessages({
  // LoginCard
  guestLogInTitle: {
    id: 'JobReportGuestAuthMessages.guestLogInTitle',
    defaultMessage: 'Guest Log In',
  },
  codeHasBeenEmailedMessage: {
    id: 'JobReportGuestAuthMessages.codeHasBeenEmailedMessage',
    defaultMessage: 'A one-time security code has been sent to {emailAddress}. It will expire in three minutes.',
    description: '{emailAddress} is a placeholder. Do not translate.',
  },
  emailCodeLabel: {
    id: 'JobReportGuestAuthMessages.emailCodeLabel',
    defaultMessage: 'Enter Code',
  },
  signInButtonLabel: {
    id: 'JobReportGuestAuthMessages.signInButtonLabel',
    defaultMessage: 'Sign In',
  },

  // GenerateCodeCard
  generateCodeTitle: {
    id: 'JobReportGuestAuthMessages.generateCodeTitle',
    defaultMessage: 'Sentinel Link Guest Access',
  },
  generateCodeMessage: {
    id: 'JobReportGuestAuthMessages.generateCodeMessage',
    defaultMessage: 'Generate a one-time security code to log in.',
  },
  generateCodeButtonLabel: {
    id: 'JobReportGuestAuthMessages.generateCodeButtonLabel',
    defaultMessage: 'Generate Security Code',
  },

  // Sentinel sign in button
  notAGuest: {
    id: 'JobReportGuestAuthMessages.notAGuest',
    defaultMessage: 'Not a Guest?',
  },
  fullExperience: {
    id: 'JobReportGuestAuthMessages.fullExperience',
    defaultMessage: 'Sign in for the full experience.',
  },
  signInNow: {
    id: 'JobReportGuestAuthMessages.signInNow',
    defaultMessage: 'Sign in Now',
  },

  // Error-related
  shareLinkExpiredTitle: {
    id: 'JobReportGuestAuthMessages.shareLinkExpiredTitle',
    defaultMessage: 'Share Link Expired',
  },
  shareLinkExpiredMessage: {
    id: 'JobReportGuestAuthMessages.shareLinkExpiredMessage',
    defaultMessage: 'This share link has expired. Contact sharer or StoneAgeSupport.',
  },
  emailAddressMissingTitle: {
    id: 'JobReportGuestAuthMessages.emailAddressMissingTitle',
    defaultMessage: 'Email Address Missing',
  },
  emailAddressMissingMessage: {
    id: 'JobReportGuestAuthMessages.emailAddressMissingMessage',
    defaultMessage: 'Invalid share link, email address missing.',
  },
  notSharedWithThisUserTitle: {
    id: 'JobReportGuestAuthMessages.notSharedWithThisUserTitle',
    defaultMessage: 'Job Report Not Shared with Current User',
  },
  notSharedWithThisUserMessage: {
    id: 'JobReportGuestAuthMessages.notSharedWithThisUserMessage',
    defaultMessage: 'This job report has not been shared with you. Contact the sharer or StoneAge support.',
  },
  logInfoNotFoundTitle: {
    id: 'JobReportGuestAuthMessages.logInfoNotFoundTitle',
    defaultMessage: 'Job Report Not Found',
  },
  logInfoNotFoundMessage: {
    id: 'JobReportGuestAuthMessages.logInfoNotFoundMessage',
    defaultMessage:
      'The job report in the share link was not found. Possible causes: bad Internet connection, job was deleted, or share link is invalid. Contact the sharer or StoneAge support.',
  },
  couldNotGenerateCodeTitle: {
    id: 'JobReportGuestAuthMessages.couldNotGenerateCodeTitle',
    defaultMessage: 'Code not generated',
  },
  couldNotGenerateCodeMessage: {
    id: 'JobReportGuestAuthMessages.couldNotGenerateCodeMessage',
    defaultMessage:
      'Something unexpected happened that prevented the code from being generated. Check your internet connection and try again, but if this occurs repeatedly contact StoneAge support.',
  },
  incorrectCodeTitle: {
    id: 'JobReportGuestAuthMessages.incorrectCodeTitle',
    defaultMessage: 'Incorrect code',
  },
  incorrectCodeMessage: {
    id: 'JobReportGuestAuthMessages.incorrectCodeMessage',
    defaultMessage:
      'The code you entered is not correct. If you believe this message is in error, contact StoneAge support.',
  },
  expiredCodeTitle: {
    id: 'JobReportGuestAuthMessages.expiredCodeTitle',
    defaultMessage: 'Code has expired',
  },
  expiredCodeMessage: {
    id: 'JobReportGuestAuthMessages.expiredCodeMessage',
    defaultMessage: 'The code that was generated has expired. Re-enter the share link and try again.',
  },
  internalErrorTitle: {
    id: 'JobReportGuestAuthMessages.internalErrorTitle',
    defaultMessage: 'Something went wrong',
  },
  internalErrorMessage: {
    id: 'JobReportGuestAuthMessages.internalErrorMessage',
    defaultMessage: 'An unexpected error occurred. If it occurs repeatedly, contact StoneAge support.',
  },
});
